import * as React from "react";
import { useMutation } from "@apollo/react-hooks";
import { CREATE_OTP, VERIFY_OTP } from "@src/hooks/useOtp/queries";
import { createOtp } from "@organisms/SignupForm/__generated__/createOtp";
import { verifyOtp } from "@organisms/SignupForm/__generated__/verifyOtp";
import { useState, useContext } from "react";
import { useAlert } from "react-alert";

import { CredentialContext, credentialType } from "@providers";

export const useOtp = () => {
  const { currentUser, setCurrentUser } = useContext<credentialType>(CredentialContext);

  const [disableOtpRequest, setDisableOtpRequest] = useState(false);
  const [otpRequested, setOtpRequested] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpId, setOtpId] = useState('');
  const [otpValue, setOtpValue] = useState('');
  const [errors, setErrors] = useState([]);

  const alert = useAlert();
  const [createOtp,] = useMutation<createOtp>(CREATE_OTP, {
    onCompleted: (data) => {
      if (data.createOtp.errors.length) {
        setErrors([...data.createOtp.errors]);
      } else {
        setOtpRequested(true);
        setDisableOtpRequest(true);
        setTimeout(() => {
          setDisableOtpRequest(false)
        }, 60000)
      }
    }
  })

  const handleRequestOtp = (rawMobileNumber: string) => {
    const mobileNumber = rawMobileNumber.trim();
    if (mobileNumber.length != 10) {
      alert.error("Mobile number must be 10 digits long!");
      return false;
    } else {
      createOtp({
        variables: { input: { 'receiver': mobileNumber } }
      })
      return true;
    }
  }

  const [verifyOtp, { data, }] = useMutation<verifyOtp>(VERIFY_OTP, {
    onCompleted: (data) => {
      if (data.verifyOtp.errors.length) {
        setErrors([...data.verifyOtp.errors]);
      } else {
        if (data.verifyOtp.verified) {
          alert.success('OTP Verified!');
          setOtpVerified(data.verifyOtp.verified);
          setOtpId(data.verifyOtp.otp.id);
          setOtpValue(data.verifyOtp.otp.value);
        } else {
          alert.error("OTP not verified!\nCheck the numbers again.");
        }
      }
    }
  });

  const handleVerifyOtp = (otp: string, mobileNumber: string, onCompleted: any = () => {
  }) => {
    verifyOtp({
      variables: {
        input: {
          'receiver': mobileNumber,
          'value': otp
        }
      }
    }).then(data => {
      if (data?.data?.verifyOtp?.verified) {
        const copyCurrentUser = JSON.parse(JSON.stringify(currentUser));
        copyCurrentUser.user.mobileNumber = Number(mobileNumber);
        copyCurrentUser.user.mobileVerified = data?.data?.verifyOtp?.verified;

        // local user info update
        setCurrentUser(copyCurrentUser);
        onCompleted(data);
      }
    });
  }

  return {
    otpRequested,
    setOtpRequested,
    otpVerified,
    setOtpVerified,
    disableOtpRequest,
    setDisableOtpRequest,
    otpId,
    otpValue,
    errors,
    handleRequestOtp,
    handleVerifyOtp
  }
}

